/**
 * Audio recording and upload store
 */
import { create } from 'zustand';
export const useAudioStore = create((set) => ({
    isRecording: false,
    recordingStartTime: null,
    recordingDuration: 0,
    uploadStatus: null,
    uploadProgress: 0,
    isUploading: false,
    error: null,
    startRecording: () => {
        set({
            isRecording: true,
            recordingStartTime: Date.now(),
            recordingDuration: 0,
            error: null,
        });
    },
    stopRecording: () => {
        set({
            isRecording: false,
            recordingStartTime: null,
        });
    },
    updateRecordingDuration: (duration) => {
        set({ recordingDuration: duration });
    },
    setUploadStatus: (status) => {
        set({
            uploadStatus: status,
            uploadProgress: status
                ? (status.uploadedChunks / status.totalChunks) * 100
                : 0,
        });
    },
    setUploadProgress: (progress) => {
        set({ uploadProgress: Math.min(100, Math.max(0, progress)) });
    },
    setUploading: (isUploading) => {
        set({ isUploading });
    },
    setError: (error) => {
        set({ error });
    },
    reset: () => {
        set({
            isRecording: false,
            recordingStartTime: null,
            recordingDuration: 0,
            uploadStatus: null,
            uploadProgress: 0,
            isUploading: false,
            error: null,
        });
    },
}));
//# sourceMappingURL=audio.js.map